import BaseApi from '@/api/Base/BaseApi'

export default class TaskApi extends BaseApi {
  getTaskList() {
    return this.agent.get<any>('/admin/job/not-completed-list')
  }

  cancelTask(aiJobId: string) {
    return this.agent.put<any>(`/ai-task/${aiJobId}/cancel`)
  }
}
